<template>
  <div class="d-flex text-blue-500 align-items-center">
    <img :src="chieldCheckFillImage" alt="ChieldCheckFill" height="35" />
    <div>{{ $t('form.formOfPayment.poweredBy') }}</div>
    <img :src="p24Image" alt="Przelewy24" height="35" class="ml-2" />
  </div>
</template>

<script setup lang="ts">
const p24Image = new URL('/src/assets/svg/p24.svg', import.meta.url).href
const chieldCheckFillImage = new URL('/src/assets/svg/chieldCheckFill.svg', import.meta.url).href
</script>
